import React from 'react';
import { HEADER_ACTIONS_SLOT_ID, HEADER_TITLE_SLOT_ID } from './headerSlots';
import styles from './MoopHeader.module.scss';
import { useMoopShell } from './MoopShellContext';

const MoopHeader: React.FC = () => {
  const { sidebarCollapsed } = useMoopShell();

  return (
    <header
      className={styles.header}
      style={{ left: sidebarCollapsed ? 'var(--sbds-sidebar-width-collapsed)' : 'var(--sbds-sidebar-width-expanded)' }}
    >
      {/* Page title + subtitle, portaled in by MoopPageHeader — see headerSlots.ts */}
      <div className={styles.left} id={HEADER_TITLE_SLOT_ID} />

      <div className={styles.right}>
        {/* Page-owned primary actions. Global utilities live in MoopSider. */}
        <div className={styles.actionsSlot} id={HEADER_ACTIONS_SLOT_ID} />
      </div>
    </header>
  );
};

export default MoopHeader;
